

import React, { Component } from 'react';
import moment from 'moment';
import cx from 'classnames';
import _groupBy from 'lodash.groupby';
import _orderBy from 'lodash.orderby';
import { Text } from '../../../ui-kit';
import EventItem from './EventItem';
import '../styles/_history-tab.scss';














function orderDates(dates, dateKey) {
  return _orderBy(dates, ({ [dateKey]: date }) => moment(date).unix(), ['desc']);
}

function groupHistoryByDay(events) {
  const groupedByDay = _groupBy(events,
  ({ createdAt }) => moment(createdAt).startOf('day').format()
  );

  const groupedByDayArray = Object.
  entries(groupedByDay).
  map(([dayDate, dayEvents]) => ({ dayDate, dayEvents: orderDates(dayEvents, 'createdAt') }));

  return orderDates(groupedByDayArray, 'dayDate');
}

export default class HistoryTab extends Component {
  constructor() {
    super();

    this.state = {
      history: []
    };
  }

  componentDidMount() {
    const { resourceHistory } = this.props;

    if (resourceHistory) {
      this.setState({ history: groupHistoryByDay(resourceHistory) });
    } else {
      this.fetchHistory();
    }
  }

  componentDidUpdate(prevProps) {
    const { resourceHistory, isInternalEventsVisible } = this.props;

    if (isInternalEventsVisible !== prevProps.isInternalEventsVisible ||
    resourceHistory !== prevProps.resourceHistory) {
      if (resourceHistory) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ history: groupHistoryByDay(resourceHistory) });
      } else {
        this.fetchHistory();
      }
    }
  }

  fetchHistory = async () => {
    const { getResourceHistory, isInternalEventsVisible } = this.props;

    const { error, data } = await getResourceHistory(isInternalEventsVisible);

    if (error) {return;}

    this.setState({ history: groupHistoryByDay(data.getResourceHistory) });
  };

  render() {
    const { children, isV2Design = false, editorId } = this.props;
    const { history } = this.state;

    return (
      <>
        {isV2Design ?
        <div className="history-tab-v2">
            {history.map(
            ({
              dayEvents


            }) =>
            <div>
                    {dayEvents.map((event) =>
              <EventItem key={event.eventId} event={event} editorId={editorId} isV2Design />
              )}
                  </div>

          )}
          </div> :

        <div className="history-tab">
            {children}
            <div className="history-tab__list">
              {history.map(
              ({
                dayDate,
                dayEvents



              }) => {
                const date = moment(dayDate);
                const isToday = date.isSame(new Date(), 'day');

                return (
                  <div
                    key={dayDate}
                    className="history-tab__list__day-activities">

                      <Text
                      heading4
                      noMargin="top"
                      className={cx(
                        'history-tab__list__day-activities__date',
                        {
                          'history-tab__list__day-activities__date--today': isToday
                        }
                      )}>

                        {date.calendar(null, {
                        sameDay: '[Today]',
                        lastDay: '[Yesterday]',
                        sameElse: 'MMMM Do YYYY',
                        lastWeek: 'MMMM Do YYYY'
                      })}
                      </Text>
                      {dayEvents.map((event) =>
                    <EventItem key={event.eventId} event={event} />
                    )}
                    </div>);

              }
            )}
            </div>
          </div>}

      </>);

  }
}